import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';


@Component({
  selector: 'app-smash-navbar-mobile',
  templateUrl: './smash-navbar-mobile.component.html',
  styleUrls: ['./smash-navbar-mobile.component.scss']
})
export class SmashNavbarMobileComponent implements OnInit, OnDestroy {
  @Input() transparent = false;
  @Output() onMenuToggle: EventEmitter<any> = new EventEmitter<any>();

  showBackButton = false;
  subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location
  ) {

    this.subscriptions.push(
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          map(() => {
            let child = this.route.firstChild;
            while (child) {
              if (child.firstChild) {
                child = child.firstChild;
              } else if (child.snapshot.data && child.snapshot.data['backableRoute']) {
                return child.snapshot.data['backableRoute'];
              } else {
                return null;
              }
            }
            return null;
          })
        ).subscribe((backableRoute) => {
          this.showBackButton = backableRoute;
        })
    )
  }

  ngOnInit(): void { }

  onBurgerMenuToggle(event) {
    this.onMenuToggle.emit(event)
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => subscription.unsubscribe());
  }

  back() {
    this._location.back();
  }

}
